var map = {
	"./class-attendance-report/locales/en.json": "260c",
	"./class-attendance-report/locales/kh.json": "04ed",
	"./class-attendance-v2/locales/en.json": "c2fc",
	"./class-attendance-v2/locales/kh.json": "a748"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "43e2";